import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import axiosInstance from "../../AxiosInstance";
import { FaCheckCircle } from "react-icons/fa";
const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [tempPassword, setTempPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [passwordResetLinkExpired, setPasswordResetLinkExpired] =
    useState(false);

  const baseURL = config.API_BASE_URL;

  const decryptToken = (token) => {
    const decodedToken = atob(token);
    const userId = decodedToken.split(":")[1];
    return userId;
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("encrypt_ref");

    if (token) {
      const userId = decryptToken(token);
      setUserId(userId);
      console.log("User ID extracted from token:", userId);

      const checkLinkExpiration = async () => {
        try {
          const response = await axiosInstance.get(
            `${baseURL}/v1/worker-users/${userId}`
          );
          if (response.data.passwordResetLinkExpired) {
            setPasswordResetLinkExpired(true);
            setErrorMessage("Expired Password Reset Link");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setErrorMessage("Error fetching user data. Please try again later.");
        }
      };

      checkLinkExpiration();
    } else {
      setErrorMessage("Invalid Password Reset Link");
    }
  }, []);

  useEffect(() => {
    if (userId && !passwordResetLinkExpired) {
      const timer = setTimeout(async () => {
        try {
          await axiosInstance.patch(`${baseURL}/v1/worker-users/${userId}`, {
            password_reset_link_expire: true,
          });
          console.log("Password reset link expired for user:", userId);
        } catch (error) {
          console.error("Error expiring password reset link:", error);
        }
      }, 20 * 60 * 1000);

      return () => clearTimeout(timer);
    }
  }, [userId, passwordResetLinkExpired]);

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (password !== password2) {
      setErrorMessage("Passwords do not match");
      return;
    }

    try {
      const verifyResponse = await axiosInstance.post(
        `${baseURL}/v1/worker-users/verify-temp-password`,
        {
          userId: userId,
          tempPassword: tempPassword,
        }
      );

      if (verifyResponse.status === 200) {
        try {
          const response = await axiosInstance.patch(
            `${baseURL}/v1/worker-users/${userId}`,
            {
              password_update: password,
            }
          );

          if (response.status === 200) {
            setSuccessMessage("Password updated successfully");
            setTimeout(() => {
              navigate("/login");
            }, 3000);
          } else {
            setErrorMessage("Failed to update password");
          }
        } catch (updateError) {
          console.error(
            "An error occurred while updating password:",
            updateError
          );
          if (updateError.response && updateError.response.data) {
            setErrorMessage(
              updateError.response.data.message ||
                "Failed to update password. Please try again."
            );
          } else {
            setErrorMessage("Failed to update password. Please try again.");
          }
        }
      } else {
        setErrorMessage("Temporary password is incorrect");
      }
    } catch (verifyError) {
      console.error(
        "An error occurred while verifying temporary password:",
        verifyError
      );
      if (verifyError.response && verifyError.response.status === 401) {
        setErrorMessage("Temporary password is incorrect");
      } else if (verifyError.response && verifyError.response.data) {
        setErrorMessage(
          verifyError.response.data.message ||
            "Failed to verify temporary password. Please try again."
        );
      } else {
        setErrorMessage(
          "Failed to verify temporary password. Please try again."
        );
      }
    }
  };

  const handleChange = (setter) => (e) => {
    setter(e.target.value);
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-logo-container">
        <img src="/images/osh_navbar_logo.png" alt="Company Logo" width="350" />
      </div>
      <div className="login-contents-container">
        <h1>Enter New Password</h1>
        <div className="login-error-message">{errorMessage}</div>
        {successMessage && (
          <div className="password-reset-success-message">
            <FaCheckCircle className="invoice-check-icon" />
            <p>{successMessage}</p>
          </div>
        )}
        <form onSubmit={handlePasswordUpdate}>
          <div className="field-container">
            <label htmlFor="password">Temporary Password</label>
            <input
              type="password"
              id="temp_password"
              value={tempPassword}
              onChange={handleChange(setTempPassword)}
              required
            />
          </div>
          <div className="field-container">
            <label htmlFor="password">New Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handleChange(setPassword)}
              required
            />
          </div>
          <div className="field-container">
            <label htmlFor="password2">Confirm New Password</label>
            <input
              type="password"
              id="password2"
              value={password2}
              onChange={handleChange(setPassword2)}
              required
            />
          </div>
          <button type="submit" disabled={errorMessage !== ""}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
